const $ = jQuery.noConflict();

const checkIfNumber = function(evt) {
	const charCode = (evt.which) ? evt.which : evt.keyCode
	if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		return false;
	}

	return true;
}

const checkPastedContents = function(spinnerInput, field, updateCartButton) {
	const currentNumberValue = spinnerInput.value;

	setTimeout(() => {
		const characters = spinnerInput.value;

		setTimeout(() => {
			if(!(/^\d+$/.test(characters))){
				spinnerInput.value = spinnerInput = currentNumberValue;

				return;
			}

			if(spinnerInput.value !== field.value) {
				if(updateCartButton !== null) {
					updateCartButton.removeAttribute('disabled');
				}

				field.value = spinnerInput.value;
			}
		});
	});
}

const decreaseValue = function(field, spinnerInput) {
	const minVal = field.getAttribute('min') ? parseInt(field.getAttribute('min')) : null;
	const step = field.getAttribute('step') ? parseInt(field.getAttribute('step')) : 1;
	const currVal = parseInt(field.value);

	if(minVal === null) {
		field.value = currVal - step;
		spinnerInput.value = currVal - step;
		return;
	}

	if(currVal > minVal) {
		field.value = currVal - step;
		spinnerInput.value = currVal - step;
	}
}

const increaseValue = function(field, spinnerInput) {
	const maxVal = field.getAttribute('max') ? parseInt(field.getAttribute('max')) : null;
	const step = field.getAttribute('step') ? parseInt(field.getAttribute('step')) : 1;
	const currVal = parseInt(field.value);

	if(maxVal === null) {
		field.value = currVal + step;
		spinnerInput.value = currVal + step;
		return;
	}

	if(currVal < maxVal) {
		field.value = currVal + step;
		spinnerInput.value = currVal + step;
	}

	if(isNaN(currVal)) {
		field.value = step;
		spinnerInput.value = step;
	}
}

const bindEvents = function(field) {
	const spinnersEl = field.previousElementSibling;
	const spinners = spinnersEl.querySelectorAll('.woo-number-spinner');
	const spinnerInput = spinnersEl.querySelector('.woo-number-spinner-input');

	const updateCartButton = document.querySelector('button[type="submit"][name="update_cart"]');

	spinnerInput.value = field.value;

	spinnerInput.addEventListener('keydown', (evt) => {
		if(!checkIfNumber(evt)) {
			evt.preventDefault();

			const currVal = parseInt(field.value);

			switch(evt.keyCode) {
				case 38:
					if(updateCartButton !== null) {
						updateCartButton.removeAttribute('disabled');
					}
					increaseValue(field, spinnerInput);
					break;
				case 40:
					if(updateCartButton !== null) {
						updateCartButton.removeAttribute('disabled');
					}
					decreaseValue(field, spinnerInput);
					break;
			}

			return;
		}
	});

	spinnerInput.addEventListener('paste', () => {
		checkPastedContents(spinnerInput, field, updateCartButton);
	});

	spinnerInput.addEventListener('keyup', () => {
		if(spinnerInput.value !== field.value) {
			if(updateCartButton !== null) {
				updateCartButton.removeAttribute('disabled');
			}

			field.value = spinnerInput.value;
		}
	});

	for (let i = 0; i < spinners.length; i++) {
		const element = spinners[i];

		element.addEventListener('click', (e) => {
			e.preventDefault();

			if(updateCartButton !== null) {
				updateCartButton.removeAttribute('disabled');
			}

			if(element.classList.contains('woo-number-spinner__up')) {
				increaseValue(field, spinnerInput);

				return;
			}

			decreaseValue(field, spinnerInput);
		});
	}
}

const addHtml = function(field) {
	field.insertAdjacentHTML('beforeBegin','<div class="woo-number-spinners" title="Qty"><input inputmode="numeric" pattern="[0-9]*" type="text" class="woo-number-spinner-input"><button class="woo-number-spinner woo-number-spinner__up"></button><button class="woo-number-spinner woo-number-spinner__down"></button></div>');

	bindEvents(field);
}

const woocommerceQuantityFields = function() {
	const quantityFields = document.querySelectorAll('.woocommerce .quantity .qty');

	for (let i = 0; i < quantityFields.length; i++) {
		const element = quantityFields[i];
		addHtml(element);
	}

	$(document.body).on('updated_cart_totals', () => {
		const spinners = document.querySelector('.woo-number-spinners');

		if(spinners === null) {
			woocommerceQuantityFields();
		}
	});
}

const woocommerceNumberFieldsInit = function() {
	woocommerceQuantityFields();
}

export default woocommerceNumberFieldsInit;